import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/content';
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6500);
    };
    const initialTimer = window.setTimeout(showPopup, 3500);
    const interval = window.setInterval(showPopup, 18000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex animate-slide-in justify-center sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-155" data-mp="3b5wnwft3busr">
      <div className="pointer-events-auto relative w-full max-w-[290px] overflow-hidden rounded-lg border-2 border-brand-green bg-brand-navy p-2.5 pr-7 text-white shadow-[0_8px_24px_rgba(6,42,77,0.45)]" data-id="element-156" data-mp="1gwcbar540j6j">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-teal" data-id="element-157" data-mp="22m6lmrihkdhf" />
        <button onClick={() => setVisible(false)} aria-label="Close purchase notification" className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-158" data-mp="1xpg6c6ei9lx2">
          <XIcon className="h-3.5 w-3.5" data-id="element-159" data-mp="2le7ummoz5k4k" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-160" data-mp="2lcof4yb57d3u">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-green bg-brand-green/20" data-id="element-161" data-mp="2ge3c6r4iafbp">
            <ShoppingBagIcon className="h-4 w-4 text-brand-green" aria-hidden="true" data-id="element-162" data-mp="2cfvxs2xilq3o" />
          </div>
          <div className="leading-tight" data-id="element-163" data-mp="14xwjmcip9pqb">
            <p className="text-[11px] font-bold" data-id="element-164" data-mp="10ye98aoi8x1q">{currentPurchase.name}</p>
            <p className="text-[10px] font-medium text-white/70" data-id="element-165" data-mp="12g2uwa8glvj4">from {currentPurchase.location}</p>
            <p className="mt-0.5 text-[10px] font-extrabold uppercase text-brand-green" data-id="element-166" data-mp="17emjkieftlf6">
              just purchased PICKLEBALL COACH PRO™
            </p>
          </div>
        </div>
      </div>
    </aside>;
}